export const queryEnums = {
  users: "getAllUsers",
  users_get: "getUserById",
  offices: "getAllOffices",
  offices_get: "getOfficeById",
  organisations: "getAllOrganisations",
  Organisations_get: "getOrganisationById",
  projects: "getAllProjects",
  projects_get: "getProjectById",
  projectsByFolderId_get: "getProjectsByFolderId",
  projects_status: "getProjectStatus",
  folders: "getAllFolders",
  folders_get: "getFolderById",
  foldersByOfficeId_get: "getFoldersByOfficeId",
  foldersByOrganisationId_get: "getFoldersByOrganisationId",
  foldersByProjectId_get: "foldersByProjectId_get",
  document_details_by_project: "getDocumentDetailsByProject",
  foreign_unmapped_organizations: "foreign_unmapped_organizations",
  foreign_mapped_organizations: "foreign_mapped_organizations",
  foreign_organization: "foreign_organization",
  foreign_organization_candidates: "foreign_organization_candidates",
  foreign_unmapped_offices: "foreign_unmapped_offices",
  foreign_mapped_offices: "foreign_mapped_offices",
  foreign_office: "foreign_office",
  foreign_office_candidates: "foreign_office_candidates",
  foreign_unmapped_projects: "foreign_unmapped_projects",
  foreign_mapped_projects: "foreign_mapped_projects",
  foreign_project: "foreign_project",
  foreign_project_candidates: "foreign_project_candidates",
  foreign_unmapped_documents: "foreign_unmapped_documents",
  foreign_mapped_documents: "foreign_mapped_documents",
  foreign_document: "foreign_document",
  foreign_document_candidates: "foreign_document_candidates",
  foreign_unmapped_folders: "foreign_unmapped_folders",
  foreign_mapped_folders: "foreign_mapped_folders",
  foreign_folder_candidates: "foreign_folder_candidates",
  foreign_external_offices: "foreign_external_offices"
};
